// SignedOutPage — C-LOGOUT.
// Mirrors review/commerce-app/auth.jsx (CmLogout).
//
// Ported from the 2026-08-26 design drop,
// handoff/commerce-app/src/pages/AuthPages.tsx `SignedOutPage`, unchanged except
// as marked.
import { Check, LogIn } from 'lucide-react';
import { Button } from '@miq/design-system/components/ui/button';

import { AuthShell } from '../components/AuthShell';
import { useDocumentTitle } from '../../lib/documentTitle';

export function SignedOutPage({ onSignInAgain }: { onSignInAgain: () => void }) {
  useDocumentTitle('Signed out');
  return (
    <AuthShell>
      <div className="mx-auto mb-4 flex size-11 items-center justify-center rounded-full bg-success-soft text-success">
        <Check className="size-5" />
      </div>
      <h1 className="text-center text-xl font-semibold tracking-tight">You&rsquo;re signed out</h1>
      <p className="mt-1 text-center text-sm text-muted-foreground">
        Your session ended securely. Metering and billing keep running unattended.
      </p>
      {/* ADAPTED: `onPress`, the React Aria event the DS Button is built on. */}
      <Button className="mt-5 w-full" onPress={onSignInAgain}>
        <LogIn className="size-4" /> Sign back in
      </Button>
    </AuthShell>
  );
}
